import type { OrganizationStatus } from '@/api/generated';

/** The order the statuses are offered in: least to most final. */
export const STATUS_ORDER: OrganizationStatus[] = [
  'PENDING',
  'ACTIVE',
  'SUSPENDED',
  'DEACTIVATED',
];

/**
 * The two moves that take something away. A reason is required for these, and
 * optional for the two that restore or precede normal service.
 *
 * Neither the user story nor the backend requires one. This is the portal's
 * rule: the reason is the only record of why, once the person who made the
 * change has moved on.
 */
export const REASON_REQUIRED: OrganizationStatus[] = ['SUSPENDED', 'DEACTIVATED'];

/** As much reason as the backend's column holds. */
export const REASON_LIMIT = 500;

/**
 * What each status does to the organization, in the words US-012 uses.
 *
 * Kept as data rather than written into the dialog, because the same sentences
 * belong anywhere else that asks someone to change a status, and because a
 * table is the thing to check against the user story when the wording is
 * questioned.
 */
export const STATUS_EFFECTS: Record<OrganizationStatus, string> = {
  PENDING:
    'The organization is not visible in the app. It is waiting to be activated, and its portal users cannot make changes.',
  ACTIVE:
    'The organization becomes visible in the app, and its portal users can make changes.',
  SUSPENDED:
    'The organization is hidden from the app and its portal users cannot make changes. Scheduled notifications are cancelled. Supporters, members and content are kept, and the account can be made active again at any time.',
  DEACTIVATED:
    'The organization is hidden from the app and its portal users cannot make changes. Scheduled notifications are cancelled. Supporters, members and content are kept. The account is treated as ended, and its name becomes available to other organizations.',
};

export function reasonIsRequired(status: OrganizationStatus | null): boolean {
  return status !== null && REASON_REQUIRED.includes(status);
}
